import styled from 'styled-components';

import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import SyncIcon from '@mui/icons-material/Sync';

const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 8px;
`;

const AnimatedSync = styled(SyncIcon)`
  animation: spin 1s linear infinite;
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;

const FadingStatusRow = styled(StatusRow)`
  opacity: 1;
  animation: fadeOut ease 1.5s;
  animation-delay: 0.5s;
  @keyframes fadeOut {
    90% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
`;

interface SaveStatusIndicatorProps {
  status: 'IDLE' | 'SAVING' | 'SAVED';
}

const SavingStatus = () => {
  return (
    <StatusRow>
      <AnimatedSync /> <span>Saving ...</span>
    </StatusRow>
  );
};

const SavedStatus = () => {
  return (
    <FadingStatusRow>
      <CheckCircleOutlineIcon color="success" /> <span>Saved!</span>
    </FadingStatusRow>
  );
};

const SaveStatusIndicator = ({ status }: SaveStatusIndicatorProps) => {
  if (status === 'IDLE') return null;

  return status === 'SAVING' ? <SavingStatus /> : <SavedStatus />;
};

export default SaveStatusIndicator;
